export default __webpack_public_path__ + "static/Menina-e-cachorro-1130d66b70fb0931f9cacce14517ef4d.jpg";